// src/ui/theme.js
import { createTheme } from "@mui/material/styles";
import { brand } from "../config/brand";

/* The `black`, `danger` and `red` slots are not decoration: `<Button
   color="black">` appears across the codebase and MUI throws on an unknown
   palette key, so they have to exist whatever the customer's colours are.
   `black` now follows the brand's primary rather than being literally black. */
export const themeFor = (p) =>
  createTheme({
    palette: {
      primary: { main: p.primary, contrastText: p.primaryContrastText },
      black: {
        main: p.primary,
        contrastText: p.primaryContrastText,
      },
      secondary: {
        main: p.secondary,
        contrastText: p.secondaryContrastText,
      },
      error: {
        main: p.error,
        contrastText: "#ffffff",
      },
      danger: {
        main: p.error,
        contrastText: "#ffffff",
      },
      warning: {
        main: p.warning,
        contrastText: "#000000",
      },
      red: { main: p.error, contrastText: "#ffffff" },
      accent: { main: p.accent, contrastText: "#ffffff" },
      /* The lit button of the organization switch, on the bar's own colour:
         the warning gold unless a palette names one, with the bar's colour as
         its text. */
      highlight: {
        main: p.highlight ?? p.warning,
        contrastText: p.primary,
      },
    },

    typography: {
      // Bump up the default weights
      fontWeightLight: 400,
      fontWeightRegular: 500,
      fontWeightMedium: 600,
      fontWeightBold: 700,

      /* OPTIONAL — make every variant a bit bolder in one shot
       Remove if you only want to tweak specific ones */
      allVariants: {
        fontWeight: 750,
      },
    },
    components: {
      MuiCardContent: {
        styleOverrides: {
          root: {
            "& .MuiTypography-iconLabel": {
              // the class we'll add below
              fontSize: "1rem", // = 16 px
              fontWeight: 600,
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root.Mui-disabled": {
              backgroundColor: "#f5f5f5", // Light gray background
              "& .MuiInputBase-input.Mui-disabled": {
                color: "#000000", // Black text
                WebkitTextFillColor: "#000000", // Override webkit default
              },
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontSize: "1.2rem",
            fontWeight: 750,
            // Big headers force tables far past a phone's width
            "@media (max-width: 600px)": {
              fontSize: "0.95rem",
            },
          },
        },
      },
    },
  });

/* The selected organization's colours over the shell's, key by key: an
   organization that configures no palette looks exactly as the app always did. */
export const organizationTheme = (organization) =>
  themeFor({ ...brand.palette, ...organization?.palette });

const theme = themeFor(brand.palette);

export default theme;
